import { render } from "./AboutUsExp.vue?vue&type=template&id=1b71979c&lang=pug"
const script = {}

import "./AboutUsExp.vue?vue&type=style&index=0&id=1b71979c&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__